<app-background-animation></app-background-animation>
<div class="accept-invite-container">
    <div class="invite-card">
        <mat-card>
            <mat-card-header>
                <div class="rotating-logo"></div>
                <h1>MedicAI</h1>
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="isLoading">
                    <mat-spinner></mat-spinner>
                    <p>Checking user authorization...</p>
                </div>
                <div *ngIf="!isLoading && isLoggedIn && errorMessage">
                    <h2>Accept Group Invite</h2>
                    <p>{{ errorMessage }}</p>
                    <p *ngIf="inviteEmail">This invite was sent to <strong>{{ inviteEmail }}</strong>.</p>
                    <button mat-raised-button color="primary" (click)="switchAccount()">Log in with a different account</button>
                    <button mat-raised-button class="m-t-10" routerLink="/patients/schedule">Back to my schedule</button>
                </div>
                <div *ngIf="!isLoading && !isLoggedIn">
                    <h2>Accept Group Invite</h2>
                    <p>To accept the group invite, please log in.</p>
                    <button mat-raised-button color="primary" (click)="login(true)">Register</button>
                    <button mat-raised-button color="primary" class="m-t-10" (click)="login()">Log In</button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>